/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import ReservationItem from 'features/GuestReschedule/components/ReservationItem';
import styled from 'styled-components';
import useGuestReschedule from 'features/GuestReschedule/hooks/useGuestReschedule';

interface ReservationItemListProps {
  readonly isSelectable?: boolean;
}

const ReservationItemList = ({
  isSelectable = true,
}: ReservationItemListProps) => {
  const { bookings, setSelectedBookingId } = useGuestReschedule();

  useEffect(() => {
    if (bookings.length === 1 && isSelectable) {
      setSelectedBookingId(bookings[0].bookingId);
    }
  }, [bookings, isSelectable]);

  return (
    <Container>
      {bookings.map((booking) => (
        <ReservationItem
          key={booking.bookingId}
          booking={booking}
          isSelectable={isSelectable}
        />
      ))}
    </Container>
  );
};

export default ReservationItemList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;
